// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b7b8ced","952":"0c316be0"}[chunkId] + ".chunk.js";
};